import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getPhoneNumberDigits(value: string) {
  return value.replace(/\D/g, "").slice(0, 11);
}

export function isGuid(value: string) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    value.trim()
  );
}

export function formatPhoneNumberInput(value: string) {
  const digits = getPhoneNumberDigits(value);

  if (!digits) {
    return "";
  }

  const hasCountryCode = digits.length > 10 && digits.startsWith("1");
  const localDigits = hasCountryCode ? digits.slice(1) : digits.slice(0, 10);
  const areaCode = localDigits.slice(0, 3);
  const prefix = localDigits.slice(3, 6);
  const lineNumber = localDigits.slice(6, 10);

  let formattedValue = hasCountryCode ? "+1" : "";

  if (areaCode) {
    formattedValue += `${formattedValue ? " " : ""}(${areaCode}`;
  }

  if (localDigits.length >= 4) {
    formattedValue += `) ${prefix}`;
  }

  if (localDigits.length >= 7) {
    formattedValue += `-${lineNumber}`;
  }

  return formattedValue;
}

/**
 * "1 booking" / "2 bookings" (EA-344). Pass `plural` for irregular words; the default adds "s".
 */
export function pluralize(count: number, singular: string, plural = `${singular}s`) {
  return count === 1 ? singular : plural;
}
